import gql from 'graphql-tag';

export const LOGIN = gql`
  mutation login($email: String!, $password: String!, $userType: UserTypeEnum!, $authenticationType: AuthenticationTypeEnum) {
    login(email: $email, password: $password, userType: $userType, authenticationType: $authenticationType) {
      authenticationToken
      userId
      currentOrganisationId
    }
  }
`;

export const queryParams = (email, password) => (
  {
    email,
    password,
    userType: 'USER',
    authenticationType: 'DEVISE_SESSION',
  }
);
